/** Refine NotificationProvider — toast через sonner. */

import type { NotificationProvider } from "@refinedev/core";
import { toast } from "sonner";

export const notificationProvider: NotificationProvider = {
  open({ message, description, type }) {
    const fn =
      type === "success"
        ? toast.success
        : type === "error"
          ? toast.error
          : toast.info;
    fn(message, { description });
  },
  close() {
    toast.dismiss();
  },
};
